document.querySelectorAll('.cookie-banner').forEach(() => {
    localStorage.getItem('SetCookieBanner') === 'true'
    ? document.querySelector('.cookie-banner').classList.add('is-hidden')
    : document.querySelector('.cookie-banner').classList.remove('is-hidden')

    document.querySelectorAll('[data-disable-cookie-banner]').forEach(el => {
        el.addEventListener('click', () => {
            localStorage.setItem('SetCookieBanner', 'true')
            document.querySelector('.cookie-banner').classList.add('is-hidden')
        })
    })  
})